// utils/Authe.js
import jwtDecode from "jwt-decode";  

// Save token (generic)
export const saveToken = (token, key = "token") => {
  const storage = key === "token" ? localStorage : sessionStorage;
  storage.setItem(key, token);
};

// Get token (generic)
export const getToken = (key = "token") => {
  const storage = key === "token" ? localStorage : sessionStorage;
  return storage.getItem(key);
};

// Remove token (generic)
export const clearToken = (key = "token") => {
  const storage = key === "token" ? localStorage : sessionStorage;
  storage.removeItem(key);
};

// ✅ Decode token
export const decodeToken = (token) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    console.error("Invalid JWT token:", error);
    return null;
  }
};

// ✅ Validate JWT token + user_type
export const isValidAdminToken = (token) => {
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    if (decoded.exp && decoded.exp < currentTime) {
      console.warn("Token expired");
      return false;
    }

    if (decoded.user_type !== "client_admin") {
      console.warn("Token is not for client_admin");
      return false;
    }

    return true;
  } catch (error) {
    console.error("Invalid token format:", error);
    return false; // ← THIS WAS MISSING IN LOGIC FLOW!
  }
};
